import { combineReducers } from '@reduxjs/toolkit';
import { gameInfoSlice } from 'modules/overlay-v2/store/game-info/game-info';
import { readinessSlice } from 'modules/overlay-v2/store/readiness/readiness';
import { overlaySlice } from './overlay/overlay';
import { timeSlice } from './time/time';

const overlayV2Reducer = combineReducers({
  overlay: overlaySlice.reducer,
  gameInfo: gameInfoSlice.reducer,
  time: timeSlice.reducer,
  readiness: readinessSlice.reducer,
});

export default overlayV2Reducer;
